import { SegmentPropertiesObject } from "./types";

/**
 * Docs for supported properties:
 * https://segment.com/docs/connections/spec/page/#properties
 */
export const getDefaultPageProperties = (): SegmentPropertiesObject => ({
  path: window.location.pathname,
  referrer: document.referrer,
  search: window.location.search,
  title: document.title,
  url: window.location.href,
});

export const getViewportProperties = (): SegmentPropertiesObject => ({
  viewportWidth: window.innerWidth,
  viewportHeight: window.innerHeight,
  devicePixelRatio: window.devicePixelRatio,
});

/**
 * Docs for supported properties:
 * https://segment.com/docs/connections/spec/common/#context-fields-automatically-collected
 */
export const getDefaultContext = (): SegmentPropertiesObject => {
  return {
    locale: navigator.language,
    page: getDefaultPageProperties(),
    screen: {
      height: window.screen.height,
      width: window.screen.width,
    },
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    userAgent: navigator.userAgent,
    userAgentData: navigator.userAgentData,
  };
};
